import {
    Header,
    CreatedAtHeader,
    ActionHeader,
    ActionDefaults,
    AmountHeader,
    EmailHeader,
    DateHeader,
} from './default';
import { RESERVATION_STATUSES } from '@/enums/statuses';
import { PERMISSIONS } from '../permissions';
import moment from 'moment';
import { hasPermission } from '@/mixins/MainMixin';

export const ReservationHeaders = [
    {
        ...Header,
        text: 'Id',
        // value: hasPermission(PERMISSIONS.reservationsDetails)
        //     ? '$$redirectedTo'
        //     : '$$default',
        value: '$$redirectedTo',
        valueFrom: 'number',
        getPath: (item) => {
            let obj = {
                path: '',
                newTab: false,
            };

            if (!item.id) return obj;

            if (item.status === RESERVATION_STATUSES.draft) {
                obj = {
                    path: `/reservation/create?id=${item.id}&draft=true`,
                    newTab: false,
                };
                return obj;
            }

            if (!hasPermission(PERMISSIONS.reservationsDetails)) {
                return { value: item };
            }

            obj = {
                path: `/reservation/details/${item.id}`,
                newTab: false,
            };
            return obj;
        },
    },
    {
        ...Header,
        text: 'Payment Type',
        value: '$$convertCase',
        convertInto: 'startCase',
        valueFrom: 'paymentType',
    },
    { ...Header, text: 'Customer Id', valueFrom: 'paypalCustomerId' },
    { ...Header, text: 'Transaction Id', valueFrom: 'transactionId' },
    { ...Header, text: 'Assigned Drivers', valueFrom: 'assignedDrivers' },

    {
        ...Header,
        text: 'Username',
        value: '$$convertCase',
        convertInto: 'startCase',
        valueFrom: 'name',
    },
    EmailHeader,
    {
        ...Header,
        text: 'Affiliate Name',
        valueFrom: 'affiliateName',
    },
    {
        ...Header,
        text: 'Return Trip',
        value: '$$redirectedTo',
        valueFrom: 'parentOfNumber',
        getPath: (item) => {
            return {
                path: item.parentOf ? `/reservation/details/${item.parentOf}` : '',
                newTab: false,
            };
        },
    },
    {
        ...Header,
        text: 'Return Trip Off',
        value: '$$redirectedTo',
        valueFrom: 'childOfNumber',
        getPath: (item) => {
            return {
                path: item.childOf ? `/reservation/details/${item.childOf}` : '',
                newTab: false,
            };
        },
    },
    {
        ...DateHeader,
        text: 'Pickup Time',
        valueFrom: 'pickUpDateTime',
    },
    {
        ...Header,
        text: 'Pickup Address',
        valueFrom: 'pickUpLocation',
    },
    {
        ...Header,
        text: 'Dropoff Address',
        valueFrom: 'dropOffLocation',
    },
    {
        ...Header,
        text: 'Hotel Name',
        valueFrom: 'hotelName',
    },
    {
        ...Header,
        text: 'Bag Checked',
        value: '$$boolean',
        getValue: ({ item }) => item.isBagsChecked,
    },
    {
        ...Header,
        text: 'Status',
        value: '$$chip',
        valueFrom: 'status',
    },
    AmountHeader,
    { ...Header, text: 'Phone', valueFrom: 'phoneNumber' },
    CreatedAtHeader,
    ActionHeader,
];

export const ReservationMeta = {
    statusKey: 'reservation',
    title: 'Reservations',
    showSelect: false,
    filters: (statuses) => {
        return [
            {
                key: 'status',
                label: 'Statuses',
                placeholder: 'Select Statuses',
                values: statuses.map((status) => ({
                    label: status.name,
                    value: status.name,
                })),
            },
            {
                key: 'filterDate',
                label: 'Dates',
                placeholder: 'Select Dates',
                singular: false,
                preCondition: (user) => {
                    if (user.isAdmin) {
                        return true;
                    }
                },
                values: [
                    {
                        label: 'Created At',
                        value: 'createdAt',
                    },
                    // {
                    //     label: 'Created Reservations',
                    //     value: 'createdAt',
                    // },
                ],
            },
        ];
    },
    headers: ReservationHeaders,
    actions: [
        {
            ...ActionDefaults.view,
            redirectTo: (item) => `/reservation/details/${item.id}`,
            preCondition: (item) => item.status !== RESERVATION_STATUSES.draft,
            permission: PERMISSIONS.reservationsDetails,
        },
        {
            ...ActionDefaults.edit,
            permission: PERMISSIONS.reservationsEdit,
            redirectTo: (item) => {
                return item.status === RESERVATION_STATUSES.draft
                    ? `/reservation/create?id=${item.id}&draft=true`
                    : `/reservation/update/${item.id}`;
            },
            preCondition: (item, user) => {
                if (
                    [
                        RESERVATION_STATUSES.completed,
                        RESERVATION_STATUSES.cancelled,
                    ].includes(item.status)
                ) {
                    return false;
                }

                if (!user.isAdmin) {
                    const duration = moment.duration(
                        moment(item.pickUpDateTime).diff(moment())
                    );
                    const hoursDifference = duration.asHours();

                    if (hoursDifference <= 6) {
                        return false;
                    }
                    return true;
                }
                return true;
            },
        },
        {
            ...ActionDefaults.assignDriver,
            permission: PERMISSIONS.reservationsAssign,
            preCondition: (item) =>
                ![
                    RESERVATION_STATUSES.draft,
                    RESERVATION_STATUSES.cancelled,
                    RESERVATION_STATUSES.completed,
                ].includes(item.status),
        },
        {
            ...ActionDefaults.create,
            permission: PERMISSIONS.reservationsCreate,
            redirectTo: () => '/reservation/create?isGettingAQuote=false',
        },
        {
            ...ActionDefaults.addAddons,
            permission: PERMISSIONS.reservationsAddAddon,
            preCondition: (item) =>
                ![RESERVATION_STATUSES.draft, RESERVATION_STATUSES.cancelled].includes(
                    item.status
                ),
        },
        {
            ...ActionDefaults.duplicate,
            permission: PERMISSIONS.reservationsDuplicate,
            redirectTo: (item) => `/reservation/create?id=${item.id}`,
            preCondition: (item) => item.status != RESERVATION_STATUSES.draft,
        },
        {
            ...ActionDefaults.complete,
            permission: PERMISSIONS.reservationsComplete,
            preCondition: (item) => item.status === RESERVATION_STATUSES.assigned,
        },
        {
            ...ActionDefaults.cancelled,
            permission: PERMISSIONS.reservationsCancel,
            preCondition: (item) =>
                ![
                    RESERVATION_STATUSES.completed,
                    RESERVATION_STATUSES.cancelled,
                ].includes(item.status),
        },
        // {
        //     ...ActionDefaults.delete,
        //     preCondition: (item) =>
        //         ![
        //             RESERVATION_STATUSES.completed,
        //             RESERVATION_STATUSES.viewed,
        //             RESERVATION_STATUSES.assigned,

    //         ].includes(item.status),
    // },
    ],
};
